import { shouldLogOutOnForbidden } from '@/lib/api/twoFactorEnrollment';
import { generalApi } from '@/lib/api/general';
import {
  dispatchCheckApiError,
  dispatchLogOut,
  MainContext,
} from '@/store/main/actionsMain';
import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';

export const actionGetEditHistories = async (
  context: MainContext,
  payload: {
    companyId: string;
    sdsId: string;
  }
) => {
  try {
    return await generalApi.getEditHistories(payload.companyId, payload.sdsId);
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};
